import { render, staticRenderFns } from "./TenantEditDialog.vue?vue&type=template&id=e98e5a58&scoped=true&"
import script from "./TenantEditDialog.vue?vue&type=script&lang=js&"
export * from "./TenantEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98e5a58",
  null
  
)

export default component.exports